import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import TitleRoxo from '../../atoms/TitleRoxo'
import Menu from '../../molecules/Menu'
import Footer from '../../molecules/Footer'
import AlertWaiting from '../../molecules/AlertWaiting'

import * as Styled from './styles'

const API_URL = 'https://moovery.app/api/indique_ganhe/index.php'
const ROTA_LOGIN = '/parceiro'

const PERFIL_CONFIG = {
  parceiro: {
    storageKey: 'parceiroData',
    tipoIndicante: 'parceiro',
    label: 'Parceiro',
    tituloPainel: 'Meu Painel de Ganhos',
    podeEditarCodigo: true,
    temPerfilEditavel: true,
    sacaViaPix: true,
    msgSaqueDestino: 'O valor será enviado via PIX para a chave cadastrada no seu perfil.',
    placeholderSemSaldo: 'Sem saldo disponível',
  },
  empresa: {
    storageKey: 'empresaData',
    tipoIndicante: 'empresa',
    label: 'Empresa',
    tituloPainel: 'Painel da Empresa',
    podeEditarCodigo: true,
    temPerfilEditavel: false,
    sacaViaPix: false,
    msgSaqueDestino: 'O valor será creditado na sua conta dentro da Moovery.',
    placeholderSemSaldo: 'Sem saldo disponível',
  },
  motoboy: {
    storageKey: 'motoboyData',
    tipoIndicante: 'entregador',
    label: 'Motoboy',
    tituloPainel: 'Painel do Motoboy',
    podeEditarCodigo: true,
    temPerfilEditavel: false,
    sacaViaPix: false,
    msgSaqueDestino: 'O valor será creditado na sua conta dentro da Moovery.',
    placeholderSemSaldo: 'Sem saldo disponível',
  },
}

const formatBRL = (v) =>
  Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

const apiCall = async (method, data) => {
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ method, data })
  })
  return res.json()
}


function detectarPerfilAtivo() {
  const tipoSalvo = localStorage.getItem('userTipoPerfil')
  if (tipoSalvo && PERFIL_CONFIG[tipoSalvo]) {
    const cfg = PERFIL_CONFIG[tipoSalvo]
    const raw = localStorage.getItem(cfg.storageKey)
    if (raw) {
      try {
        return { tipo: tipoSalvo, dados: JSON.parse(raw), config: cfg }
      } catch (e) { /* continua para fallback */ }
    }
  }

  for (const [tipo, cfg] of Object.entries(PERFIL_CONFIG)) {
    const raw = localStorage.getItem(cfg.storageKey)
    if (raw) {
      try {
        return { tipo, dados: JSON.parse(raw), config: cfg }
      } catch (e) { /* ignora */ }
    }
  }

  return null
}

export default function Painel() {
  const history = useHistory()

  const [perfilAtivo, setPerfilAtivo] = useState(null)
  const [usuario, setUsuario] = useState(null)

  // Estados individuais de dados e carregamento progressivo
  const [saldo, setSaldo] = useState(0)
  const [saldoEmAnalise, setSaldoEmAnalise] = useState(0)
  const [loadingSaldo, setLoadingSaldo] = useState(true)

  const [indicacoes, setIndicacoes] = useState([])
  const [loadingIndicacoes, setLoadingIndicacoes] = useState(true)

  const [transacoes, setTransacoes] = useState([])
  const [loadingTransacoes, setLoadingTransacoes] = useState(true)

  const [saquePendente, setSaquePendente] = useState(null)
  const [loadingSaquePendente, setLoadingSaquePendente] = useState(true)

  const [copied, setCopied] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  const [cancelandoSaque, setCancelandoSaque] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [novoCodigo, setNovoCodigo] = useState('')
  const [savingCodigo, setSavingCodigo] = useState(false)

  const [isSaqueModalOpen, setIsSaqueModalOpen] = useState(false)
  const [valorSaque, setValorSaque] = useState('')
  const [savingSaque, setSavingSaque] = useState(false)
  const [saqueMsg, setSaqueMsg] = useState({ type: '', text: '' })
  const [saqueStep, setSaqueStep] = useState('valor') // 'valor' | 'otp'
  const [codigoOtp, setCodigoOtp] = useState('')
  const [enviandoOtp, setEnviandoOtp] = useState(false)

  const [isDetalhesModalOpen, setIsDetalhesModalOpen] = useState(false)
  const [detalhes, setDetalhes] = useState(null)
  const [loadingDetalhes, setLoadingDetalhes] = useState(false)

  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false)
  const [savingProfile, setSavingProfile] = useState(false)
  const [profileMsg, setProfileMsg] = useState({ type: '', text: '' })
  const [profileForm, setProfileForm] = useState({
    nome: '', email: '', telefone: '', tipo_chave_pix: '', chave_pix: ''
  })

  const maskMoney = (value) => {
    const digits = value.replace(/\D/g, '')
    if (!digits) return ''
    const cents = (parseInt(digits, 10) / 100).toFixed(2)
    return cents.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  const maskPhone = (value) =>
    value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4,5})(\d{4})$/, '$1-$2')
      .slice(0, 15)

  // Dispara as 4 requisições em paralelo de forma independente
  const fetchTudo = useCallback((cfg, id) => {
    setLoadingSaldo(true)
    setLoadingIndicacoes(true)
    setLoadingTransacoes(true)
    setLoadingSaquePendente(true)

    // 1. Saldo / Financeiro (libera assim que responder)
    apiCall('getSaldoIndicante', {
      tipo_indicante: cfg.tipoIndicante,
      indicante_id: id
    })
      .then((resSaldo) => {
        if (resSaldo && resSaldo.success) {
          setSaldo(resSaldo.saldo)
          setSaldoEmAnalise(resSaldo.saldo_em_analise || 0)
        }
      })
      .catch((err) => console.error('Erro ao carregar saldo:', err))
      .finally(() => setLoadingSaldo(false))

    // 2. Indicações e métricas (libera assim que responder)
    apiCall('getMinhasIndicacoes', {
      tipo_indicante: cfg.tipoIndicante,
      indicante_id: id
    })
      .then((resInd) => {
        if (resInd && resInd.success) {
          setIndicacoes(resInd.data || [])
        }
      })
      .catch((err) => console.error('Erro ao carregar indicações:', err))
      .finally(() => setLoadingIndicacoes(false))

    // 3. Histórico de transações (libera assim que responder)
    apiCall('getHistoricoTransacoesIndicante', {
      tipo_indicante: cfg.tipoIndicante,
      indicante_id: id,
      limit: 100
    })
      .then((resTrans) => {
        if (resTrans && resTrans.success) {
          setTransacoes(resTrans.data || [])
        }
      })
      .catch((err) => console.error('Erro ao carregar transações:', err))
      .finally(() => setLoadingTransacoes(false))

    // 4. Checar saque pendente (libera assim que responder)
    apiCall('checarSaquePendente', {
      tipo_indicante: cfg.tipoIndicante,
      indicante_id: id
    })
      .then((resPendente) => {
        if (resPendente && resPendente.success) {
          setSaquePendente(resPendente.pendente)
        }
      })
      .catch((err) => console.error('Erro ao checar saque pendente:', err))
      .finally(() => setLoadingSaquePendente(false))
  }, [])

  useEffect(() => {
    const detectado = detectarPerfilAtivo()
    if (!detectado) {
      history.push(ROTA_LOGIN)
      return
    }
    setPerfilAtivo(detectado)
    setUsuario(detectado.dados)
    setNovoCodigo(detectado.dados.codigo_indicacao || '')
    fetchTudo(detectado.config, detectado.dados.id)
  }, [history, fetchTudo])

  const recarregarFinanceiro = async () => {
    if (!perfilAtivo) return
    const { config, dados } = perfilAtivo
    setLoadingSaldo(true)
    setLoadingTransacoes(true)
    setLoadingSaquePendente(true)

    apiCall('getSaldoIndicante', {
      tipo_indicante: config.tipoIndicante,
      indicante_id: dados.id
    })
      .then((resSaldo) => {
        if (resSaldo && resSaldo.success) {
          setSaldo(resSaldo.saldo)
          setSaldoEmAnalise(resSaldo.saldo_em_analise || 0)
        }
      })
      .catch((err) => console.error('Erro ao recarregar saldo:', err))
      .finally(() => setLoadingSaldo(false))

    apiCall('getHistoricoTransacoesIndicante', {
      tipo_indicante: config.tipoIndicante,
      indicante_id: dados.id,
      limit: 100
    })
      .then((resTrans) => {
        if (resTrans && resTrans.success) {
          setTransacoes(resTrans.data || [])
        }
      })
      .catch((err) => console.error('Erro ao recarregar transações:', err))
      .finally(() => setLoadingTransacoes(false))

    apiCall('checarSaquePendente', {
      tipo_indicante: config.tipoIndicante,
      indicante_id: dados.id
    })
      .then((resPendente) => {
        if (resPendente && resPendente.success) {
          setSaquePendente(resPendente.pendente)
        }
      })
      .catch((err) => console.error('Erro ao recarregar saque pendente:', err))
      .finally(() => setLoadingSaquePendente(false))
  }

  const handleCopyLink = () => {
    if (!usuario || !usuario.codigo_indicacao) return
    // Mantém o cadastro de empresa como rota de captação por padrão
    const link = `https://moovery.com.br/cadastro-empresa?ref=${usuario.codigo_indicacao}`
    navigator.clipboard.writeText(link)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handleLogout = () => {
    Object.values(PERFIL_CONFIG).forEach(c => localStorage.removeItem(c.storageKey))
    localStorage.removeItem('userTipoPerfil')
    history.push(ROTA_LOGIN)
  }

  const handleSaveCodigo = async () => {
    setErrorMsg('')
    const codigoFormatado = novoCodigo.toUpperCase().trim()

    if (!/^[A-Z0-9]{1,10}$/.test(codigoFormatado)) {
      setErrorMsg('Formato inválido. Use até 10 letras e números (sem espaços ou acentos).')
      return
    }

    setSavingCodigo(true)
    try {
      const result = await apiCall('gravarNovoCodigo', {
        tipo: perfilAtivo.tipo,
        id: usuario.id,
        novo_codigo: codigoFormatado
      })

      if (result.success) {
        const usuarioAtualizado = { ...usuario, codigo_indicacao: codigoFormatado }
        setUsuario(usuarioAtualizado)
        localStorage.setItem(perfilAtivo.config.storageKey, JSON.stringify(usuarioAtualizado))
        setIsModalOpen(false)
      } else {
        setErrorMsg(result.message || 'Erro ao atualizar o código.')
      }
    } catch {
      setErrorMsg('Erro de conexão com o servidor.')
    } finally {
      setSavingCodigo(false)
    }
  }

  const openSaqueModal = () => {
    setValorSaque('')
    setCodigoOtp('')
    setSaqueStep('valor')
    setSaqueMsg({ type: '', text: '' })
    setIsSaqueModalOpen(true)
  }

  // Etapa 1: usuário informou o valor — solicita OTP por e-mail
  const handleSolicitarOtp = async () => {
    setSaqueMsg({ type: '', text: '' })
    const valorNumerico = parseFloat(valorSaque.replace(/\./g, '').replace(',', '.'))

    if (!valorNumerico || valorNumerico <= 0) {
      setSaqueMsg({ type: 'error', text: 'Informe um valor válido maior que zero.' })
      return
    }
    if (valorNumerico > saldo) {
      setSaqueMsg({ type: 'error', text: `Saldo insuficiente. Disponível: ${formatBRL(saldo)}` })
      return
    }

    setEnviandoOtp(true)
    try {
      const result = await apiCall('solicitarCodigoSaque', {
        tipo_indicante: perfilAtivo.config.tipoIndicante,
        indicante_id: usuario.id
      })

      if (result.success) {
        setSaqueStep('otp')
        setSaqueMsg({ type: 'success', text: result.message })
      } else {
        setSaqueMsg({ type: 'error', text: result.message || 'Erro ao solicitar código.' })
      }
    } catch {
      setSaqueMsg({ type: 'error', text: 'Erro de conexão com o servidor.' })
    } finally {
      setEnviandoOtp(false)
    }
  }

  // Etapa 2: usuário digitou OTP — confirma o saque
  const handleSaque = async () => {
    setSaqueMsg({ type: '', text: '' })

    const valorNumerico = parseFloat(valorSaque.replace(/\./g, '').replace(',', '.'))
    const codigoLimpo   = (codigoOtp || '').replace(/\D/g, '')

    if (!valorNumerico || valorNumerico <= 0) {
      setSaqueMsg({ type: 'error', text: 'Valor inválido.' })
      return
    }
    if (codigoLimpo.length !== 6) {
      setSaqueMsg({ type: 'error', text: 'Informe os 6 dígitos do código de confirmação.' })
      return
    }

    setSavingSaque(true)
    try {
      const result = await apiCall('solicitarSaqueIndicante', {
        tipo_indicante: perfilAtivo.config.tipoIndicante,
        indicante_id: usuario.id,
        valor: valorNumerico,
        codigo_otp: codigoLimpo
      })

      if (result.success) {
        setSaqueMsg({ type: 'success', text: result.message })
        if (typeof result.novo_saldo !== 'undefined') setSaldo(result.novo_saldo)
        await recarregarFinanceiro()
        setTimeout(() => setIsSaqueModalOpen(false), 2000)
      } else {
        setSaqueMsg({ type: 'error', text: result.message || 'Erro ao solicitar o saque.' })
      }
    } catch {
      setSaqueMsg({ type: 'error', text: 'Erro de conexão com o servidor.' })
    } finally {
      setSavingSaque(false)
    }
  }

  const openDetalhesModal = async (indicacaoId) => {
    setIsDetalhesModalOpen(true)
    setDetalhes(null)
    setLoadingDetalhes(true)

    try {
      const result = await apiCall('getDetalhesIndicacaoIndicante', {
        indicacao_id: indicacaoId,
        tipo_indicante: perfilAtivo.config.tipoIndicante,
        indicante_id: usuario.id
      })
      if (result.success) {
        setDetalhes(result)
      } else {
        setDetalhes({ error: result.message || 'Erro ao carregar detalhes.' })
      }
    } catch {
      setDetalhes({ error: 'Erro de conexão com o servidor.' })
    } finally {
      setLoadingDetalhes(false)
    }
  }

  const handleCancelarSaquePendente = async () => {
    if (!saquePendente) return
    if (!window.confirm('Tem certeza que deseja cancelar esta solicitação de saque?')) return

    setCancelandoSaque(true)
    try {
      const result = await apiCall('cancelarSaqueParceiro', {
        parceiro_id: usuario.id,
        solicitacao_id: saquePendente.id
      })

      if (result.success) {
        setSaquePendente(null)
        await recarregarFinanceiro()
      } else {
        alert(result.message || 'Erro ao cancelar saque.')
      }
    } catch {
      alert('Erro de conexão com o servidor.')
    } finally {
      setCancelandoSaque(false)
    }
  }

  const openProfileModal = () => {
    setProfileForm({
      nome: usuario.nome || '',
      email: usuario.email || '',
      telefone: usuario.telefone || '',
      tipo_chave_pix: usuario.tipo_chave_pix || '',
      chave_pix: usuario.chave_pix || ''
    })
    setProfileMsg({ type: '', text: '' })
    setIsProfileModalOpen(true)
  }

  const handleSaveProfile = async () => {
    setProfileMsg({ type: '', text: '' })
    setSavingProfile(true)
    const emailChanged = profileForm.email !== usuario.email

    try {
      const result = await apiCall('editarDadosParceiro', {
        id: usuario.id, ...profileForm
      })

      if (result.success) {
        const usuarioAtualizado = { ...usuario, ...profileForm }
        setUsuario(usuarioAtualizado)
        localStorage.setItem(perfilAtivo.config.storageKey, JSON.stringify(usuarioAtualizado))

        if (emailChanged) {
          setProfileMsg({ type: 'success', text: 'Dados salvos! Enviamos um código para confirmar seu novo e-mail.' })
        } else {
          setProfileMsg({ type: 'success', text: 'Perfil atualizado com sucesso!' })
          setTimeout(() => setIsProfileModalOpen(false), 1500)
        }
      } else {
        setProfileMsg({ type: 'error', text: result.message || 'Erro ao atualizar dados.' })
      }
    } catch {
      setProfileMsg({ type: 'error', text: 'Erro de conexão com o servidor.' })
    } finally {
      setSavingProfile(false)
    }
  }

  if (!perfilAtivo || !usuario) return null

  const { config } = perfilAtivo
  const totalIndicacoes   = indicacoes.length
  const totalEmpresas     = indicacoes.filter(i => i.tipo === 'Empresa').length
  const totalEntregadores = indicacoes.filter(i => i.tipo === 'Entregador').length

  // Bloqueia o botão de saque se for Parceiro sem chave PIX
  const parceiroSemPix = config.sacaViaPix && (!usuario.chave_pix || !usuario.tipo_chave_pix)
  const temPendencia   = !!saquePendente
  const podeResgatar   = saldo > 0 && !parceiroSemPix && !temPendencia

  const tituloSaqueDisabled = saldo <= 0
    ? config.placeholderSemSaldo
    : (parceiroSemPix
      ? 'Cadastre uma chave PIX no seu perfil'
      : (temPendencia ? 'Aguarde a aprovação ou cancele o saque pendente' : 'Solicitar saque'))

  const primeiroNome = (usuario.nome || '').split(' ')[0] || ''

  return (
    <>
      <Menu hideLinks />
      <Styled.Page>
        <Styled.Container>

          <Styled.HeaderArea>
            <div>
              <Styled.Greeting>Olá, {primeiroNome} 👋</Styled.Greeting>
              <TitleRoxo>{config.tituloPainel}</TitleRoxo>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              {config.temPerfilEditavel && (
                <Styled.ProfileButton onClick={openProfileModal}>Meu Perfil</Styled.ProfileButton>
              )}
              <Styled.LogoutButton onClick={handleLogout}>Sair</Styled.LogoutButton>
            </div>
          </Styled.HeaderArea>

          {/* ===== Cards principais: Saldo + Código ===== */}
          <Styled.CardsRow>
            <Styled.BalanceCard>
              <Styled.BalanceLabel>Saldo disponível</Styled.BalanceLabel>

              {loadingSaldo ? (
                <>
                  <Styled.SkeletonDark height="40px" width="180px" radius="10px" />
                  <Styled.SkeletonDark height="22px" width="130px" radius="8px" />
                  <Styled.SkeletonDark height="42px" width="120px" radius="10px" style={{ marginTop: '0.25rem' }} />
                </>
              ) : (
                <>
                  <Styled.BalanceValue>{formatBRL(saldo)}</Styled.BalanceValue>

                  {saldoEmAnalise > 0 && (
                    <Styled.BalanceSubInfo>
                      Em análise: <strong>{formatBRL(saldoEmAnalise)}</strong>
                    </Styled.BalanceSubInfo>
                  )}

                  <Styled.WithdrawButton
                    onClick={openSaqueModal}
                    disabled={!podeResgatar}
                    title={tituloSaqueDisabled}
                  >
                    Resgatar
                  </Styled.WithdrawButton>
                </>
              )}
            </Styled.BalanceCard>

            <Styled.CodeCard>
              <Styled.CodeInfo>
                <p>Seu código exclusivo:</p>
                <div className="codigo-box">
                  <h2>{usuario.codigo_indicacao || '—'}</h2>
                  {config.podeEditarCodigo && (
                    <button
                      onClick={() => {
                        setNovoCodigo(usuario.codigo_indicacao || '')
                        setErrorMsg('')
                        setIsModalOpen(true)
                      }}
                      className="edit-btn"
                      title="Personalizar Código"
                    >
                      ✎
                    </button>
                  )}
                </div>
              </Styled.CodeInfo>
              <Styled.CopyButton
                onClick={handleCopyLink}
                className={copied ? 'copied' : ''}
                disabled={!usuario.codigo_indicacao}
              >
                {copied ? '✓ Link Copiado!' : 'Copiar Link de Indicação'}
              </Styled.CopyButton>
            </Styled.CodeCard>
          </Styled.CardsRow>

          {/* ===== Banner de saque pendente ===== */}
          {!loadingSaquePendente && saquePendente && (
            <Styled.PendingBanner>
              <div className="content">
                <div className="icon">⏳</div>
                <div className="text">
                  <strong>Saque em análise: {formatBRL(saquePendente.valor)}</strong>
                  <span>
                    Solicitado em {saquePendente.data} • Você receberá um e-mail assim que o financeiro processar o PIX.
                  </span>
                </div>
              </div>
              <button
                className="btn-cancel-pending"
                onClick={handleCancelarSaquePendente}
                disabled={cancelandoSaque}
              >
                {cancelandoSaque ? 'Cancelando...' : 'Cancelar saque'}
              </button>
            </Styled.PendingBanner>
          )}

          {/* ===== Resumo das indicações ===== */}
          <Styled.StatsGrid>
            <Styled.StatCard>
              {loadingIndicacoes ? (
                <div style={{ display: 'flex', justifyContent: 'center', margin: '0.25rem 0' }}>
                  <Styled.Skeleton height="36px" width="60px" radius="8px" />
                </div>
              ) : (
                <h3>{totalIndicacoes}</h3>
              )}
              <p>Total de Indicações</p>
            </Styled.StatCard>
            <Styled.StatCard>
              {loadingIndicacoes ? (
                <div style={{ display: 'flex', justifyContent: 'center', margin: '0.25rem 0' }}>
                  <Styled.Skeleton height="36px" width="60px" radius="8px" />
                </div>
              ) : (
                <h3>{totalEmpresas}</h3>
              )}
              <p>Empresas</p>
            </Styled.StatCard>
            <Styled.StatCard>
              {loadingIndicacoes ? (
                <div style={{ display: 'flex', justifyContent: 'center', margin: '0.25rem 0' }}>
                  <Styled.Skeleton height="36px" width="60px" radius="8px" />
                </div>
              ) : (
                <h3>{totalEntregadores}</h3>
              )}
              <p>Motoboys</p>
            </Styled.StatCard>
          </Styled.StatsGrid>

          {/* ===== Acompanhamento das indicações ===== */}
          <Styled.SectionTitle>Acompanhamento em Tempo Real</Styled.SectionTitle>

          {loadingIndicacoes ? (
            <Styled.IndicationsList>
              {[1, 2, 3].map((k) => (
                <Styled.SkeletonCard key={k}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', width: '60%' }}>
                      <Styled.Skeleton height="20px" width="180px" radius="6px" />
                      <Styled.Skeleton height="14px" width="140px" radius="4px" />
                    </div>
                    <Styled.Skeleton height="26px" width="110px" radius="999px" />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginTop: '0.25rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Styled.Skeleton height="14px" width="130px" radius="4px" />
                      <Styled.Skeleton height="14px" width="50px" radius="4px" />
                    </div>
                    <Styled.Skeleton height="8px" width="100%" radius="999px" />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.25rem' }}>
                    <Styled.Skeleton height="32px" width="110px" radius="8px" />
                  </div>
                </Styled.SkeletonCard>
              ))}
            </Styled.IndicationsList>
          ) : indicacoes.length === 0 ? (
            <Styled.EmptyState>
              Você ainda não fez nenhuma indicação. Copie seu link acima e comece a compartilhar!
            </Styled.EmptyState>
          ) : (
            <Styled.IndicationsList>
              {indicacoes.map((ind) => {
                const meta = ind.meta || 0
                const progresso = meta > 0
                  ? Math.min((ind.entregas / meta) * 100, 100).toFixed(0)
                  : 0
                const isConcluido = meta > 0 && ind.entregas >= meta
                const entregasExibidas = meta > 0 ? Math.min(ind.entregas, meta) : ind.entregas

                return (
                  <Styled.IndicationCard key={ind.id}>
                    <Styled.IndicationHeader>
                      <div className="info">
                        <strong>{ind.nome}</strong>
                        <span>{ind.tipo} • Indicado em {ind.data}</span>
                      </div>
                      <Styled.StatusBadge className={isConcluido ? 'success' : 'pending'}>
                        {isConcluido ? 'Meta Atingida' : 'Em Progresso'}
                      </Styled.StatusBadge>
                    </Styled.IndicationHeader>

                    <Styled.ProgressBarContainer>
                      <div className="labels">
                        <span>Progresso de Entregas</span>
                        <span>{entregasExibidas} / {meta || '—'}</span>
                      </div>
                      <Styled.ProgressBar>
                        <Styled.ProgressFill
                          style={{ width: `${progresso}%` }}
                          className={isConcluido ? 'success' : ''}
                        />
                      </Styled.ProgressBar>
                    </Styled.ProgressBarContainer>

                    <Styled.IndicationActions>
                      <button onClick={() => openDetalhesModal(ind.id)} className="btn-details">
                        Ver detalhes
                      </button>
                    </Styled.IndicationActions>
                  </Styled.IndicationCard>
                )
              })}
            </Styled.IndicationsList>
          )}

          {/* ===== Histórico de transações ===== */}
          <Styled.SectionTitle>Histórico de Transações</Styled.SectionTitle>

          {loadingTransacoes ? (
            <Styled.TransactionsList>
              {[1, 2, 3, 4].map((k) => (
                <Styled.SkeletonRow key={k}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', width: '70%' }}>
                    <Styled.Skeleton height="26px" width="75px" radius="999px" />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', width: '100%' }}>
                      <Styled.Skeleton height="18px" width="60%" radius="6px" />
                      <Styled.Skeleton height="13px" width="30%" radius="4px" />
                    </div>
                  </div>
                  <Styled.Skeleton height="22px" width="80px" radius="6px" />
                </Styled.SkeletonRow>
              ))}
            </Styled.TransactionsList>
          ) : transacoes.length === 0 ? (
            <Styled.EmptyState>
              Você ainda não tem transações registradas no programa Indique e Ganhe.
            </Styled.EmptyState>
          ) : (
            <Styled.TransactionsList>
              {transacoes.map((t) => (
                <Styled.TransactionRow key={t.id} className={t.tipo}>
                  <div className="left">
                    <div className={`tipo-badge ${t.tipo}`}>
                      {t.tipo === 'credito' ? '↑ Entrada' : '↓ Saída'}
                    </div>
                    <div className="info">
                      <strong>{t.descricao || (t.tipo === 'credito' ? 'Comissão de indicação' : 'Saque')}</strong>
                      <span>{t.data}</span>
                    </div>
                  </div>
                  <div className={`valor ${t.tipo}`}>
                    {t.tipo === 'credito' ? '+ ' : '− '}{formatBRL(t.valor)}
                  </div>
                </Styled.TransactionRow>
              ))}
            </Styled.TransactionsList>
          )}

        </Styled.Container>
      </Styled.Page>

      {/* ============ Modal: editar código ============ */}
      {isModalOpen && (
        <Styled.ModalOverlay onClick={(e) => { if (e.target === e.currentTarget) setIsModalOpen(false) }}>
          <Styled.ModalContent>
            <h3>Personalize seu Código</h3>
            <p className="desc">Crie um código fácil de lembrar para atrair mais indicados. <span>(Ex: JOAO2026)</span></p>

            <input
              type="text"
              maxLength={10}
              value={novoCodigo}
              onChange={(e) => setNovoCodigo(e.target.value.toUpperCase())}
              placeholder="Digite o novo código"
              className="main-input-modal"
            />

            {errorMsg && <div className="error-msg">{errorMsg}</div>}

            <div className="actions">
              <button className="btn-cancel" onClick={() => setIsModalOpen(false)} disabled={savingCodigo}>
                Cancelar
              </button>
              <button className="btn-save" onClick={handleSaveCodigo} disabled={savingCodigo || !novoCodigo.trim()}>
                {savingCodigo ? 'Salvando...' : 'Salvar Código'}
              </button>
            </div>
          </Styled.ModalContent>
        </Styled.ModalOverlay>
      )}

      {/* ============ Modal: saque (2 etapas: valor -> otp) ============ */}
      {isSaqueModalOpen && (
        <Styled.ModalOverlay onClick={(e) => { if (e.target === e.currentTarget && !savingSaque && !enviandoOtp) setIsSaqueModalOpen(false) }}>
          <Styled.ModalContent>
            <h3>Solicitar Saque</h3>
            <p className="desc">
              Saldo disponível: <strong>{formatBRL(saldo)}</strong>
            </p>

            {parceiroSemPix && (
              <div className="status-msg error">
                Você precisa cadastrar uma chave PIX no seu perfil antes de solicitar um saque.
              </div>
            )}

            {saqueStep === 'valor' && (
              <>
                <div className="form-group">
                  <label>Valor a resgatar (R$)</label>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={valorSaque}
                    onChange={(e) => setValorSaque(maskMoney(e.target.value))}
                    placeholder="0,00"
                    className="main-input-modal"
                  />
                </div>

                <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.5rem' }}>
                  {config.msgSaqueDestino}
                  {config.sacaViaPix && usuario.chave_pix
                    ? ` (${usuario.tipo_chave_pix}: ${usuario.chave_pix})`
                    : ''}
                </p>

                {config.sacaViaPix ? (
                  <div className="status-msg" style={{ background: '#fff8e1', color: '#b45309', textAlign: 'left' }}>
                    ⏳ <strong>Importante:</strong> seu saque ficará <strong>em análise</strong> até o financeiro
                    da Moovery processar o PIX (até 2 dias úteis).
                    Enquanto estiver pendente, você não poderá solicitar um novo saque,
                    mas pode cancelar este pedido a qualquer momento.
                  </div>
                ) : (
                  <p style={{ fontSize: '0.85rem', color: '#2e7d32', marginTop: '0.25rem', fontWeight: 600 }}>
                    ✓ O crédito é imediato.
                  </p>
                )}

                <p style={{ fontSize: '0.85rem', color: '#7241a1', marginTop: '0.5rem', fontWeight: 600 }}>
                  🔒 Por segurança, vamos enviar um código de confirmação para o seu e-mail.
                </p>

                {saqueMsg.text && (
                  <div className={`status-msg ${saqueMsg.type}`}>
                    {saqueMsg.text}
                  </div>
                )}

                <div className="actions">
                  <button className="btn-cancel" onClick={() => setIsSaqueModalOpen(false)} disabled={enviandoOtp}>
                    Cancelar
                  </button>
                  <button
                    className="btn-save"
                    onClick={handleSolicitarOtp}
                    disabled={enviandoOtp || !valorSaque || parceiroSemPix}
                  >
                    {enviandoOtp ? 'Enviando código...' : 'Continuar'}
                  </button>
                </div>
              </>
            )}

            {saqueStep === 'otp' && (
              <>
                <div className="status-msg success" style={{ textAlign: 'left' }}>
                  Você está prestes a sacar <strong>{formatBRL(parseFloat((valorSaque || '0').replace(/\./g, '').replace(',', '.')) || 0)}</strong>.
                </div>

                <p className="desc" style={{ marginTop: '0.5rem' }}>
                  Enviamos um código de 6 dígitos para o seu e-mail{usuario.email ? ` (${usuario.email})` : ''}.
                  Digite-o abaixo para confirmar o saque.
                </p>

                <div className="form-group">
                  <label>Código de Confirmação</label>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={6}
                    value={codigoOtp}
                    onChange={(e) => setCodigoOtp(e.target.value.replace(/\D/g, ''))}
                    placeholder="000000"
                    className="main-input-modal"
                    style={{ letterSpacing: '8px', textAlign: 'center', fontSize: '1.6rem' }}
                    autoFocus
                  />
                </div>

                <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.25rem', textAlign: 'center' }}>
                  Não recebeu?{' '}
                  <span
                    onClick={enviandoOtp ? undefined : handleSolicitarOtp}
                    style={{
                      color: '#7241a1',
                      cursor: enviandoOtp ? 'not-allowed' : 'pointer',
                      fontWeight: 700,
                      textDecoration: 'underline'
                    }}
                  >
                    {enviandoOtp ? 'Enviando...' : 'Reenviar código'}
                  </span>
                </p>

                {saqueMsg.text && (
                  <div className={`status-msg ${saqueMsg.type}`}>
                    {saqueMsg.text}
                  </div>
                )}

                <div className="actions">
                  <button
                    className="btn-cancel"
                    onClick={() => { setSaqueStep('valor'); setCodigoOtp(''); setSaqueMsg({ type: '', text: '' }) }}
                    disabled={savingSaque}
                  >
                    Voltar
                  </button>
                  <button
                    className="btn-save"
                    onClick={handleSaque}
                    disabled={savingSaque || codigoOtp.length !== 6}
                  >
                    {savingSaque ? 'Processando...' : 'Confirmar Saque'}
                  </button>
                </div>
              </>
            )}
          </Styled.ModalContent>
        </Styled.ModalOverlay>
      )}

      {/* ============ Modal: detalhes da indicação ============ */}
      {isDetalhesModalOpen && (
        <Styled.ModalOverlay onClick={(e) => { if (e.target === e.currentTarget) setIsDetalhesModalOpen(false) }}>
          <Styled.ModalContent className="large">
            <h3>Detalhes da Indicação</h3>

            {loadingDetalhes && <p className="desc">Carregando entregas vinculadas...</p>}

            {!loadingDetalhes && detalhes?.error && (
              <div className="status-msg error">{detalhes.error}</div>
            )}

            {!loadingDetalhes && detalhes?.success && (
              <>
                <Styled.DetailsHeader>
                  <div>
                    <strong>{detalhes.indicacao.nome}</strong>
                    <span>{detalhes.indicacao.tipo} • Indicado em {detalhes.indicacao.data_indicacao}</span>
                  </div>
                  <Styled.DetailsStats>
                    <div>
                      <span>Entregas finalizadas</span>
                      <strong>{detalhes.indicacao.total_finalizadas}</strong>
                    </div>
                    <div>
                      <span>Meta</span>
                      <strong>{detalhes.indicacao.meta || '—'}</strong>
                    </div>
                    <div>
                      <span>Comissões pagas</span>
                      <strong>{formatBRL(detalhes.indicacao.total_comissionado)}</strong>
                    </div>
                  </Styled.DetailsStats>
                </Styled.DetailsHeader>

                <h4 style={{ margin: '1.5rem 0 0.75rem 0' }}>Entregas vinculadas</h4>

                {detalhes.entregas.length === 0 ? (
                  <Styled.EmptyState>
                    Ainda não há entregas registradas para este indicado após a data da indicação.
                  </Styled.EmptyState>
                ) : (
                  <Styled.DeliveryTable>
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>Data</th>
                      <th>Status</th>
                      <th>Comissão</th>
                    </tr>
                    </thead>
                    <tbody>
                    {detalhes.entregas.map((e) => (
                      <tr key={e.id}>
                        <td>#{e.id}</td>
                        <td>{e.data}</td>
                        <td>
                            <span className={`status ${e.finalizada ? 'success' : 'pending'}`}>
                              {e.status}
                            </span>
                        </td>
                        <td>
                          {e.gerou_comissao
                            ? <span className="comissao">+ {formatBRL(e.valor_comissao)}</span>
                            : <span className="muted">—</span>}
                        </td>
                      </tr>
                    ))}
                    </tbody>
                  </Styled.DeliveryTable>
                )}
              </>
            )}

            <div className="actions">
              <button className="btn-cancel" onClick={() => setIsDetalhesModalOpen(false)}>
                Fechar
              </button>
            </div>
          </Styled.ModalContent>
        </Styled.ModalOverlay>
      )}

      {/* ============ Modal: meu perfil (apenas perfis com temPerfilEditavel) ============ */}
      {isProfileModalOpen && (
        <Styled.ModalOverlay onClick={(e) => { if (e.target === e.currentTarget) setIsProfileModalOpen(false) }}>
          <Styled.ModalContent className="large">
            <h3>Meu Perfil</h3>
            <p className="desc" style={{ marginBottom: '1rem' }}>Mantenha seus dados de contato e recebimento atualizados.</p>

            <div className="form-group">
              <label>Nome Completo</label>
              <input
                type="text"
                value={profileForm.nome}
                onChange={(e) => setProfileForm({ ...profileForm, nome: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Telefone / WhatsApp</label>
              <input
                type="text"
                value={profileForm.telefone}
                onChange={(e) => setProfileForm({ ...profileForm, telefone: maskPhone(e.target.value) })}
              />
            </div>

            <div className="form-grid-2">
              <div className="form-group">
                <label>Tipo de Chave Pix</label>
                <select
                  value={profileForm.tipo_chave_pix}
                  onChange={(e) => setProfileForm({ ...profileForm, tipo_chave_pix: e.target.value })}
                >
                  <option value="">Selecione...</option>
                  <option value="cpf">CPF</option>
                  <option value="cnpj">CNPJ</option>
                  <option value="telefone">Celular</option>
                  <option value="email">E-mail</option>
                  <option value="aleatoria">Chave Aleatória</option>
                </select>
              </div>
              <div className="form-group">
                <label>Chave Pix</label>
                <input
                  type="text"
                  value={profileForm.chave_pix}
                  onChange={(e) => setProfileForm({ ...profileForm, chave_pix: e.target.value })}
                />
              </div>
            </div>

            <div className="form-group">
              <label>E-mail de Acesso</label>
              <input
                type="email"
                value={profileForm.email}
                onChange={(e) => setProfileForm({ ...profileForm, email: e.target.value.toLowerCase() })}
              />
              <span className="warning-text">
                ⚠️ Se você alterar o e-mail, enviaremos um código de confirmação para o novo endereço.
              </span>
            </div>

            {profileMsg.text && (
              <div className={`status-msg ${profileMsg.type}`}>
                {profileMsg.text}
              </div>
            )}

            <div className="actions">
              <button className="btn-cancel" onClick={() => setIsProfileModalOpen(false)} disabled={savingProfile}>
                Fechar
              </button>
              <button className="btn-save" onClick={handleSaveProfile} disabled={savingProfile}>
                {savingProfile ? 'Salvando...' : 'Salvar Alterações'}
              </button>
            </div>
          </Styled.ModalContent>
        </Styled.ModalOverlay>
      )}

      <Footer />
    </>
  )
}
